'use strict';

import React, {useState} from 'react';
import {observer} from "mobx-react";
import PropTypes from 'prop-types';
import { flow, observable, configure, action, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import Modal from "react-bootstrap/Modal"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Alert from 'react-bootstrap/Alert';

import appStore from "@uw-it-sis/lib-react/lib/AppStore";
import {States} from "@uw-it-sis/lib-react/lib/AppConstants";
import Loader from "@uw-it-sis/lib-react/lib/Loader";

import Api from './utils/Api';

// Normally this goes in a separate file, but it's so small I'm keeping it here.
class DeleteUserStore {
    state = States.initial;
    errorMessage = null;

    constructor() {
        makeObservable(this, {
            state: observable,
            errorMessage: observable,
            clearError: action
        });
    }

    clearError() { this.errorMessage = null; }

    submit = flow(function* () {
        this.state = States.pending;
        try {
            yield Api.deleteProfile();
            // If the response was successful, we'll refresh the page.
            appStore.doRefresh();
            this.state = States.done;
        }
        catch (error) {
            this.errorMessage = error.message;
            this.state = States.error;
            return;
        }

    });
}

const store = new DeleteUserStore();

const DeleteUser = observer(({openComponent = Button}) => {
    const [showModal, setShowModal] = useState(false);

    const open = () => setShowModal(true);
    const close = () => setShowModal(false);
    const isPending = () => store.state === States.pending;
    const submit = async () => {
        if (!isPending()) {
            store.submit();
        }
    };

    const OpenComponent = openComponent;
    let isButtonOpenComponent = OpenComponent.hasOwnProperty("displayName") && OpenComponent.displayName === "Button";
    return (
        <>
            <OpenComponent
                variant={isButtonOpenComponent ? "outline-danger" : undefined}
                onClick={open}
            >
                Delete User
            </OpenComponent>
            <Modal id="modal-delete-user"
                show={showModal}
                onHide={close}
                size="sm"
                autoFocus={false}
                // onEntered={onEntered}
                aria-labelledby="modal-delete-user-title"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id="modal-delete-user-title">Delete User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Loader show={store.state === States.pending}>
                        <Form.Group id="deleteUser">
                            <p>This functionality is only available in the dev environment.</p>
                            <p>This will delete the current user's profile from Notify.UW. This action cannot be undone.</p>
                            <p>Are you sure?</p>
                        </Form.Group>
                        { store.errorMessage && <Alert variant="danger" aria-live="polite" aria-atomic={true}>{store.errorMessage}</Alert> }
                    </Loader>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={submit} disabled={isPending()}>
                        Delete
                    </Button>
                    <Button variant="secondary" onClick={close}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
});

DeleteUser.propTypes = {
    openComponent: PropTypes.elementType
};

export default DeleteUser;
